import { IContent } from "src/ScrollyInterface";
import {
  IGetDataAction,
  INavigationClickedAction,
  INavigationFinishedAction,
  IScrollClickedAction,
  IScrollFinishedAction,
  ISetMediaLoadedAction,
  ISetScrollDirectionAction
} from "src/store//StoreInterface";
import * as actionTypes from "src/store/actions//actionTypes";

export const getData = (data: IContent): IGetDataAction => {
  return {
    payload: data,
    type: actionTypes.GET_DATA
  };
};

export const navigationClicked = (id: number): INavigationClickedAction => {
  return {
    payload: id,
    type: actionTypes.NAVIGATION_CLICKED
  };
};

export const navigationFinished = (): INavigationFinishedAction => {
  return {
    type: actionTypes.NAVIGATION_FINISHED
  };
};

export const setMediaLoaded = (mediaLoaded: boolean): ISetMediaLoadedAction => {
  return {
    payload: mediaLoaded,
    type: actionTypes.SET_MEDIA_LOADED
  };
};

export const setScrollDirection = (
  scrollDirection: "up" | "down"
): ISetScrollDirectionAction => {
  return {
    payload: scrollDirection,
    type: actionTypes.SET_SCROLL_DIRECTION
  };
};

export const scrollClicked = (): IScrollClickedAction => {
  return {
    type: actionTypes.SCROLL_CLICKED
  };
};

export const scrollFinished = (): IScrollFinishedAction => {
  return {
    type: actionTypes.SCROLL_FINISHED
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/data.tsx